
import { Options } from "vue-class-component";
import { Answer } from "../../../../../model/Answer.model";
import Base from "../../../../base/Base.vue";
@Options({
  props: ["question"]
})
export default class Answers extends Base {
  question: any = [];
  removeAnswer(index: any) {
    this.question.answers.splice(index, 1);
  }

  addAnswer() {
    this.question.answers.push({ name: "" } as Answer);
  }
}
